import { render, staticRenderFns } from "./OrderConfirm.vue?vue&type=template&id=a6b4f3da&scoped=true&"
import script from "./OrderConfirm.vue?vue&type=script&lang=js&"
export * from "./OrderConfirm.vue?vue&type=script&lang=js&"
import style0 from "./OrderConfirm.vue?vue&type=style&index=0&id=a6b4f3da&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b4f3da",
  null
  
)

export default component.exports